import { Component, OnInit } from '@angular/core';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-vaulttovaultmigration',
    templateUrl: './vaulttovaultmigration.component.html',
    styleUrls: ['./vaulttovaultmigration.component.scss'],
    standalone: false
})
export class VaulttovaultmigrationComponent implements OnInit {
  backgroundColorButton;
  name:any;
  vaultDNS 
  dataTransfer
  responserequest
  constructor(private userRoutingModule: UserRoutingModule,private retrieveScreenAccess: RetrieveScreenAccess,private linkservice: ReportlinksserviceService,private localStorageSettings: LocalStorageSettingsService) { }

  ngOnInit() {
    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });

    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      const buttonIdList: number[] = [];
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }

      console.log('Button ID List:', buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
        

        
      });
    });
  }

  verify(){
    console.log("Verified");
  }

}
